import { baseUrl } from '~/config/public/environment';

export const getBaseCanonicalUrl = (pathname = '/') =>
  `${baseUrl}${pathname.toLowerCase()}`;
